import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { callGetWishlistMetadata, WISHLISTS_DATA } from '@app/client/resources/wishlists';
import { PathParams } from '@app/routes/types';

interface GetWishlistMetadataArgs {
    providedSlug?: string;
    disabled?: boolean;
}
export const useGetWishlistMetadata = (args?: GetWishlistMetadataArgs) => {
    const { providedSlug, disabled } = args || {};
    const { [PathParams.WishlistSlug]: wishlistSlug } = useParams();

    const slug = providedSlug || wishlistSlug || '';
    const cache = [WISHLISTS_DATA, slug];
    const enabled = Boolean(slug) && !disabled;

    return useQuery({
        queryKey: cache,
        queryFn: ({ signal }) =>
            callGetWishlistMetadata({
                slug,
                settings: {
                    signal,
                },
            }),
        retry: false,
        placeholderData: keepPreviousData,
        enabled,
        select: (res) => {
            if (res?.ok && res.value) {
                return res.value;
            }
        },
    });
};
